
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/management-team",
      function () {
        return require("private-next-pages/about-us/management-team.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/management-team"])
      });
    }
  